import React from 'react'

const SecureFetchContext = React.createContext();

export default SecureFetchContext